import React from 'react';
import { MockCard, MockHeader, MeterBar, StaggerRow } from './shell';

const SPLITS = [
  { piece: '0\u2013500', split: '1:33.2', rate: 36, pct: 96 },
  { piece: '500\u20131000', split: '1:35.8', rate: 32, pct: 88 },
  { piece: '1000\u20131500', split: '1:36.1', rate: 32, pct: 86 },
  { piece: '1500\u20132000', split: '1:33.3', rate: 35, pct: 95 },
];

function Gauge({ label, value, pct, tone }) {
  return (
    <div className="rounded-xl border border-slate-100 bg-slate-50/70 p-3">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
      <p className="mt-0.5 font-mono text-xl font-bold text-slate-900">{value}</p>
      <div className="mt-2">
        <MeterBar pct={pct} className={tone} delay={0.2} />
      </div>
    </div>
  );
}

export default function ResultsMockup() {
  return (
    <MockCard>
      <MockHeader
        title={'2k Test \u2014 Men\u2019s Heavyweight'}
        subtitle={'Submitted from the app \u00b7 J. Okafor'}
        right={
          <span className="shrink-0 rounded-full bg-blue-50 px-2.5 py-1 text-[11px] font-semibold text-blue-700 ring-1 ring-inset ring-blue-100">
            Coach template
          </span>
        }
      />

      <div className="px-4 py-4">
        <div className="flex items-end gap-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
              2000m
            </p>
            <p className="font-mono text-4xl font-bold leading-none text-slate-900">6:18.4</p>
          </div>
          <p className="pb-1 text-xs font-semibold text-slate-500">avg 1:34.6 &middot; r33</p>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3">
          <Gauge label="% of goal 2k" value="98.7%" pct={98.7} tone="bg-blue-600" />
          <Gauge label="% GMS" value="91.2%" pct={91.2} tone="bg-amber-500" />
        </div>

        <div className="mt-4">
          <div className="mb-1.5 flex items-center justify-between text-[10px] font-semibold uppercase tracking-wider text-slate-400">
            <span>Piece</span>
            <span className="flex gap-4">
              <span>Split</span>
              <span className="w-6 text-right">r</span>
            </span>
          </div>
          <div className="space-y-1">
            {SPLITS.map((s, i) => (
              <StaggerRow
                key={s.piece}
                index={i}
                className="flex items-center justify-between rounded-md bg-slate-50/70 px-2.5 py-1.5"
              >
                <span className="text-xs text-slate-600">{s.piece}m</span>
                <span className="flex items-center gap-4">
                  <span className="font-mono text-xs font-semibold text-slate-900">{s.split}</span>
                  <span className="w-6 text-right font-mono text-xs text-slate-500">{s.rate}</span>
                </span>
              </StaggerRow>
            ))}
          </div>
        </div>

        <div className="mt-3 flex items-center gap-2 border-t border-slate-100 pt-3 text-[11px] text-slate-500">
          <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />
          Split and stroke rate captured for every piece
        </div>
      </div>
    </MockCard>
  );
}
